import axios from '@/user/axios.js'
import { fileDownload } from '@/utils'

const moduleKeywordReports = {
  namespaced: true,
  state: {
    keywordReports: [],
    sp: [],
    sb: [],
    sd: []
  },
  getters: {},
  mutations: {
    SET_KEYWORD_REPORTS (state, data) {
      state.keywordReports = data
    },
    SET_SP (state, data) {
      state.sp = data
    },
    SET_SB (state, data) {
      state.sb = data
    },
    SET_SD (state, data) {
      state.sd = data
    }
  },
  actions: {
    fetchkeywordReports: async (context, payload) => {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/keyword-reports/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_KEYWORD_REPORTS', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchSP: async (context, payload) => {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/keyword-reports/${sellerId}/sp`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_SP', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchSB: async (context, payload) => {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/keyword-reports/${sellerId}/sb`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_SB', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchSD: async (context, payload) => {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/keyword-reports/${sellerId}/sd`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_SD', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadCSV (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        const { action, ...params } = payload
        try {
          const res = await axios.get(`/api/keyword-reports/download/${sellerId}/${action}`, {
            responseType: 'blob',
            params
          })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadUnionAllCSV (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        const { ...params } = payload
        try {
          const res = await axios.get(`/api/keyword-reports/download/${sellerId}`, {
            responseType: 'blob',
            params
          })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleKeywordReports
